import { addClassName } from '@hc-frontend/core-utils-format';

import type { CardProps } from './card.types';

export function CardHeader({
  children,
  className,
  ...props
}: React.ComponentProps<'div'>) {
  return (
    <div
      className={addClassName(
        'hc-typography--heading-four',
        'py-4-8',
        'text-center',
        'bg-background-100',
        'rounded-t-lg',
        'font-semibold',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}

export function CardBody({
  children,
  className,
  ...props
}: React.ComponentProps<'div'>) {
  return (
    <div
      className={addClassName(
        'bg-gray-0 p-24-32 max-h-full overflow-y-auto',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}

export function CardFooter({
  children,
  className,
  ...props
}: React.ComponentProps<'div'>) {
  return (
    <div
      className={addClassName(
        'hc-typography--paragraph-md',
        'py-8-12',
        'text-center',
        'bg-secondary-900',
        'rounded-b-lg',
        'font-bold',
        'text-text-0',
        'font-bold',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}

export function Card({ className, children, ...props }: CardProps) {
  return (
    <div
      className={addClassName(
        'hc-stack-layout',
        'rounded-b-lg',
        'rounded-t-lg',
        'border-background-200',
        'border-solid',
        'border',
        'w-fit',
        '[&_>_*]:[--hc-stack-layout-space:0rem]',
        '[&_>_:first-child]:rounded-t-lg',
        '[&>:nth-last-child(-n+1)]:rounded-b-lg',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}
